import { readEnv } from '../config/env';

export const CX_BASE_DOMAIN = readEnv('VITE_CX_BASE_DOMAIN', '');

const LOCAL_HOSTS = new Set(['127.0.0.1', '::1', 'localhost']);
const LOCAL_CX_BASE_DOMAIN = 'localhost';

export function normalizeHost(host: string): string {
  return host.trim().toLowerCase().replace(/\.$/, '').replace(/:\d+$/, '');
}

export function isLocalHost(host: string): boolean {
  return LOCAL_HOSTS.has(normalizeHost(host));
}

function localTenantSlugFromHost(host: string): string | null {
  const normalizedHost = normalizeHost(host);
  const suffix = `.${LOCAL_CX_BASE_DOMAIN}`;
  if (!normalizedHost.endsWith(suffix)) return null;

  const slug = normalizedHost.slice(0, -suffix.length);
  return slug && !slug.includes('.') ? slug : null;
}

export function isOwnedCxHost(host: string, baseDomain = CX_BASE_DOMAIN): boolean {
  const normalizedHost = normalizeHost(host);
  const normalizedBase = normalizeHost(baseDomain);

  if (isLocalHost(normalizedHost)) return false;
  if (localTenantSlugFromHost(normalizedHost)) return true;
  if (!normalizedBase) return false;

  return normalizedHost === normalizedBase || normalizedHost.endsWith(`.${normalizedBase}`);
}

export function tenantSlugFromHost(host: string, baseDomain = CX_BASE_DOMAIN): string | null {
  const normalizedHost = normalizeHost(host);
  const localSlug = localTenantSlugFromHost(normalizedHost);
  if (localSlug) return localSlug;

  if (!isOwnedCxHost(host, baseDomain)) return null;

  const normalizedBase = normalizeHost(baseDomain);

  if (normalizedHost === normalizedBase) return null;

  const slug = normalizedHost.slice(0, -(normalizedBase.length + 1));

  return slug && !slug.includes('.') ? slug : null;
}

export function normalizeExternalUrl(url: string): string | null {
  const trimmed = url.trim();
  if (!trimmed) return null;

  const withProtocol = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

  try {
    const parsed = new URL(withProtocol);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
    return parsed.toString();
  } catch {
    return null;
  }
}
